import classNames from 'classnames';
import { Template } from 'devextreme-react/core/template';
import LoadPanel from 'devextreme-react/load-panel';
import { RangeRule, Validator } from 'devextreme-react/validator';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import { custom } from 'devextreme/ui/dialog';
import { useToggle } from 'fulogics-ui-core/dist/layout/hooks/useToggle';
import LabelStaticValue from 'fulogics-ui-web/dist/layout/components/label-static-value/LabelStaticValue';
import {
    LogisticUnitSimpleTextData,
    LogisticUnitSimpleTextDataKeys,
} from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import RouteLocationModelSimpleText, {
    RouteLocationModelSimpleTextData,
} from 'fulogics-ui-web/dist/layout/components/route-location-model-simple-text/RouteLocationModelSimpleText';
import Button from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import CheckBox from 'fulogics-ui-web/dist/layout/dx/CheckBox/CheckBox';
import DataGrid from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import CellTemplateProps from 'fulogics-ui-web/dist/layout/dx/DataGrid/templates/CellTemplateProps';
import Form from 'fulogics-ui-web/dist/layout/dx/Form/Form';
import Lookup from 'fulogics-ui-web/dist/layout/dx/Lookup/Lookup';
import NumberBox from 'fulogics-ui-web/dist/layout/dx/NumberBox/NumberBox';
import Popup from 'fulogics-ui-web/dist/layout/dx/Popup/Popup';
import SelectBox from 'fulogics-ui-web/dist/layout/dx/SelectBox/SelectBox';
import { useMemoDataSource } from 'fulogics-ui-web/dist/layout/hooks/useMemoDataSource';
import { useVStore } from 'fulogics-ui-web/dist/layout/hooks/useVStore';
import InspectorVariablesContext from 'fulogics-ui-web/dist/layout/inspector/context/InspectorVariablesContext';
import LayoutControl from 'fulogics-ui-web/dist/layout/layout-control/LayoutControl';
import toast from 'fulogics-ui-web/dist/utils/toast';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import enArrowDirection from '../../../api/enums/enArrowDirection';
import {
    insertByProductIdToCollectionPayload,
    insertBySSCCListToCollectionPayload,
} from '../../../store/models/COSOrderForwardStepPayloadModel';
import {
    getWMSDetailsPayload,
    PayloadWMSDetailsData,
    ProductInfoStore,
} from '../../../store/models/ProductInfoModel';
import { WarehouseStore } from '../../../store/models/WarehouseModel';
import { WMSProductCarriersStore } from '../../../store/models/WMSBasicStocksModel';
import { iRootDispatch, iRootState } from '../../../store/store';
import i18n from '../../../translations/i18n';
import PayloadCarrierCountSimpleTextTemplate from '../../templates/dataGrid/column/payload-carrier-count-simple-text-template/PayloadCarrierCountSimpleTextTemplate';
import AllowedStacksHeaderTemplate from '../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeaderTemplate';
import {
    PayloadCarrierCountSimpleTextData,
    PayloadCarrierCountSimpleTextDataKeys,
} from '../payload-carrier-count-simple-text/PayloadCarrierCountSimpleText';
import ProgressBarBoxes, { RemainingTrailerSpace } from '../progress-bar-boxes/ProgressBarBoxes';
import {
    orderStepForwardFormHeaderId,
    payloadAddFormAddButtonId,
    payloadAddFormAdvancedApplyButtonId,
    payloadAddFormAdvancedCancelButtonId,
    payloadAddFormAdvanceHeaderLayoutId,
    payloadAddFormAdvanceLayoutId,
    payloadAddFormCancelButtonId,
    payloadAddFormCountOfCarriersToGetId,
    payloadAddFormDoneButtonId,
    payloadAddFormOpenAdvancedButtonId,
    payloadAddFormProductsGridId,
    payloadAddFormProductToAddInfoFormId,
    payloadAddFormProductToAddSelectBoxId,
    payloadAddFormProductWarehouseToAddSelectBoxId,
    payloadAddFormRemoveAllButtonId,
    payloadFormGridId,
} from './inspectorOptions';
import styles from './PayloadAddForm.module.scss';

const mapStateToProps = (state: iRootState) => ({
    // to idzie z parenta
    /*createPayloadDataSource: (payloadCollectionId?: string) => {
        let opts = COSOrderForwardStepPayloadStore.createByCollectionId(payloadCollectionId)
        //
        opts.select = OrderForwardStepPayloadItemDataKeys;
        //
        return new DataSource(opts)
    },*/
    createProductToAddDataSource: () => {
        let opts = {
            store: ProductInfoStore,
            select: ProductToAddSelectBoxInfoDataKeys,
        } as DataSourceOptions;
        //
        return opts; // ProductToAddSelectBoxInfoData
    },
    createWarehousesDataSource: () => {
        let opts = {
            store: WarehouseStore,
            select: LogisticUnitSimpleTextDataKeys,
        } as DataSourceOptions;
        //
        return opts;
    },
    createProductCarriersDataSource: (warehouseId?: string) => {
        //if (!warehouseId) return undefined;
        //
        let opts = {
            store: WMSProductCarriersStore,
            select: ProductCarrierItemDataKeys,
            customQueryParams: {
                //warehouseId,
            },
            /*map: (dataItem: ProductCarrierItemData) => {
                let r = {
                    ...dataItem,
                    //
                    stockAttributesFlat: {},
                };
                //
                dataItem?.stockAttributes?.forEach((item) => {
                    (r.stockAttributesFlat as any)[item.attributeName as string] =
                        item.attributeValue;
                });
                //
                return r;
            },*/
        } as DataSourceOptions;
        //
        return opts;
    },
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: PayloadAddFormDisplayOptions) =>
    ({
        insertPayloadItemByProductId: (payload?: insertByProductIdToCollectionPayload) =>
            // @ts-ignore
            _dispatch.COSOrderForwardStepPayload.insertByProductIdToCollection<PayloadAddFormPayloadData>(
                {
                    responseDataKeys: PayloadAddFormPayloadDataKeys,
                    //
                    ...payload,
                }
            ),
        insertPayloadItemBySSCCList: (payload: insertBySSCCListToCollectionPayload) =>
            // @ts-ignore
            _dispatch.COSOrderForwardStepPayload.insertBySSCCListToCollection<PayloadAddFormPayloadData>(
                {
                    // info z backendu : nie wiemy jaki response przyjdzie
                    //responseDataKeys: PayloadAddFormPayloadDataKeys,
                    //
                    ...payload,
                }
            ),
        //
        getWMSDetails: _dispatch?.ProductInfo?.getWMSDetails,
        //
        ..._ownDispatch,
    } as PayloadAddFormDisplayOptions);

// Todo
// obłsuga deletepayload jako podpięcie do dataGrid

const formDetailsLoadPanelPosition = { of: '#formDetails' };

const AdvancedCheckBoxCell = (p: {
    data: {
        key?: any;
        data?: ProductCarrierItemData;
        value?: any;
        component?: dxDataGrid;
    };
}) => {
    const props = p.data;
    const selected = ((props as any).component as any)?.getSelectedRowsData();
    const isVisible =
        !selected ||
        selected.filter((q: ProductCarrierItemData) => q.productName !== props.data?.productName)
            .length === 0;

    const onValueChanged = useCallback(
        (e: { value?: boolean }) => {
            if (!p?.data?.component?.getDataSource().isLoading()) {
                e.value
                    ? props.component?.selectRows([props.key], true)
                    : props.component?.deselectRows([props.key]);
            }
        },
        [props.component, props.key]
    );

    return (
        <GridColumnInspectorHelper cellProps={props as CellTemplateProps}>
            {(inspectorId, disableInspectorForm) => (
                <CheckBox
                    disableInspectorForm={disableInspectorForm}
                    inspectorId={inspectorId}
                    defaultValue={props.value}
                    visible={isVisible}
                    disabled={p?.data?.component?.getDataSource().isLoading()}
                    onValueChanged={onValueChanged}
                />
            )}
        </GridColumnInspectorHelper>
    );
};

const PayloadAddForm = connect(
    mapStateToProps,
    mapDispatch as any
)((props: PayloadAddFormProps) => {
    const payloadDataSource = useMemoDataSource(
        () => props.createPayloadDataSource?.(props.data?.payload?.id),
        [props.data?.payload?.id]
    );
    const productToAddDataSource = useMemoDataSource(
        () => props.createProductToAddDataSource?.(),
        []
    );
    const productWarehousesToAddDataSource = useMemoDataSource(
        () => props.createWarehousesDataSource?.(),
        []
    );
    const [selectedProductToAdd, setSelectedProductToAdd] =
        useState<ProductToAddSelectBoxInfoData | undefined>();
    const [selectedProductToAddInfoFormData, setSelectedProductToAddInfoFormData] =
        useState<ProductToAddInfoFormData | undefined>();
    const [selectedProductWarehouseToAdd, setSelectedProductWarehouseToAdd] =
        useState<string | undefined>();
    const [countOfCarriersToGet, setCountOfCarriersToGet] = useState<number>();
    const [insertingPayloadItem, setInsertingPayloadItem] = useState<boolean>(false);
    const [insertingPayloadItemBySSCCList, setInsertingPayloadItemBySSCCList] =
        useState<boolean>(false);
    const [
        isAdvancedStockPopupVisible,
        toggleAdvancedStockPopup,
        setAdvancedStockPopup,
        setAdvancedStockPopupFalse,
    ] = useToggle();

    useEffect(() => {
        const handleDataChange = () => {
            props.calculateRemainingTrailerSpace?.();
        };
        payloadDataSource?.on('changed', handleDataChange);
        return () => {
            payloadDataSource?.off('changed', handleDataChange);
        };
    }, [payloadDataSource, props.calculateRemainingTrailerSpace]);

    const productCarriersDataSource = useMemo(
        () =>
            !!selectedProductWarehouseToAdd
                ? {
                      store: WMSProductCarriersStore,
                      select: ProductCarrierItemDataKeys,
                      customQueryParams: { warehouseId: selectedProductWarehouseToAdd },
                      filter: [
                          ['carrierStatus', '=', 'Unreserved'],
                          'and',
                          ['stockStatus', '=', 'Unreserved'],
                      ],
                  }
                : undefined,
        [selectedProductWarehouseToAdd]
    );

    const [advancedSelectedKeys, setAdvancedSelectedKeys] = useState<string[]>([]);
    const vStore = useVStore(
        () => ({
            variables: {
                disableAdvancedDoneButton: advancedSelectedKeys?.length === 0,
            },
        }),
        [advancedSelectedKeys]
    );
    //
    const { t } = useTranslation('PayloadAddForm');

    const { getWMSDetails } = props;
    const refreshDetails = useCallback(
        (productId?: string, warehouseId?: string) => {
            setSelectedProductToAddInfoFormData(undefined);
            //
            if (!!productId && !!warehouseId) {
                getWMSDetails?.({
                    productId: productId,
                    warehouseId: warehouseId,
                })
                    ?.then((r) => {
                        setSelectedProductToAddInfoFormData({
                            ...selectedProductToAdd,
                            ...r,
                        });
                    })
                    .catch((er) => {
                        toast.exception(er);
                    });
            }
        },
        [getWMSDetails, setSelectedProductToAddInfoFormData, selectedProductToAdd]
    );
    const onProductWarehouseToAddSelectBoxValueChanged = useCallback((e: { value?: any }) => {
        setSelectedProductWarehouseToAdd(e.value);
        setSelectedProductToAdd(undefined);
        setAdvancedSelectedKeys([]);
    }, []);
    const onProductToAddSelectBoxValueChanged = useCallback(
        (e: { value?: any }) => {
            setSelectedProductToAdd(e.value);
            setCountOfCarriersToGet(0);
            //
            refreshDetails(e.value?.id, selectedProductWarehouseToAdd?.toString() ?? '-1');
        },
        [refreshDetails, selectedProductWarehouseToAdd]
    );
    const { insertPayloadItemByProductId, data } = props;
    const onPayloadAddFormAddButtonClick = useCallback(
        (e?: React.FormEvent<HTMLFormElement>) => {
            e?.preventDefault();
            setInsertingPayloadItem(true);
            insertPayloadItemByProductId?.({
                collectionId: data?.payload?.id ?? '-1',
                //
                warehouseId: selectedProductWarehouseToAdd ?? '-1',
                productId: selectedProductToAdd?.id ?? '-1',
                //
                count: countOfCarriersToGet ?? -1,
            })
                .then(() => {
                    setSelectedProductToAdd(undefined);
                    setSelectedProductToAddInfoFormData(undefined);
                    setInsertingPayloadItem(false);
                })
                .catch((error) => {
                    toast.exception(error);
                    setInsertingPayloadItem(false);
                });
            //
        },
        [
            countOfCarriersToGet,
            insertPayloadItemByProductId,
            data?.payload?.id,
            selectedProductToAdd?.id,
            selectedProductWarehouseToAdd,
        ]
    );

    const onRemoveStepDialog = () => {
        return custom({
            messageHtml: `<div class="confirmCustomDialogContainer">
        <div class="confirmCustomDialogContainerTop">${t(
            'removeAllProducts'
        )}</div><div class="confirmCustomDialogContainerBottom">${t(
                'confirmRemoveALlProducts'
            )}</div></div>`,
            showTitle: false,
            buttons: [
                {
                    // text: "t~OrderNewScreenDonePopup:confirmOrder",
                    text: i18n.t('PayloadAddForm:cancel'),
                    type: 'danger',
                    stylingMode: 'contained',
                },
                {
                    stylingMode: 'contained',
                    type: 'success',
                    // text: "t~OrderNewScreenDonePopup:cancel",
                    text: i18n.t('PayloadAddForm:confirm'),
                    onClick: async (e) => {
                        const items = payloadDataSource?.items();
                        if (!items) return;

                        for (let i = 0; i < items?.length; i++) {
                            await payloadDataSource?.store().remove(items[i].id);
                        }

                        payloadDataSource?.reload();
                    },
                },
            ],
        });
    };

    const onAdvancedSelectionChanged = useCallback((e: { selectedRowKeys?: string[] }) => {
        setAdvancedSelectedKeys(e.selectedRowKeys ?? []);
    }, []);

    const onAdvancedAddButtonClick = useCallback(() => {
        if (advancedSelectedKeys?.length === 0) return;
        //

        setInsertingPayloadItemBySSCCList(true);

        props
            .insertPayloadItemBySSCCList?.({
                collectionId: props.data?.payload?.id ?? '-1',
                //
                carrierSSCCList: advancedSelectedKeys,
            })
            .then(() => {
                setAdvancedSelectedKeys([]);
                toggleAdvancedStockPopup();
                //
                payloadDataSource?.reload();
                setInsertingPayloadItemBySSCCList(false);
            })
            .catch((error) => {
                toast.exception(error);
                setInsertingPayloadItemBySSCCList(false);
            });
    }, [payloadDataSource, advancedSelectedKeys, props.insertPayloadItemBySSCCList]);

    const onRemoveAll = useCallback(() => {
        onRemoveStepDialog().show();
    }, [onRemoveStepDialog]);

    const [isPayloadAddFormDisable, setPayloadAddFormDisable] = useState<boolean>(true);

    const carrierCountInRange =
        !!countOfCarriersToGet &&
        countOfCarriersToGet <=
            (selectedProductToAddInfoFormData?.totalAvailableProductUnitsSum || 0);

    useEffect(() => {
        if (selectedProductWarehouseToAdd && selectedProductToAdd && countOfCarriersToGet) {
            setPayloadAddFormDisable(false);
        } else {
            setPayloadAddFormDisable(true);
        }
    }, [selectedProductWarehouseToAdd, selectedProductToAdd, countOfCarriersToGet]);

    return (
        <div className={classNames(styles.container, props.className)}>
            <InspectorVariablesContext store={vStore}>
                <div className={classNames(styles.top)}>
                    <header>
                        <RouteLocationModelSimpleText
                            inspectorId={orderStepForwardFormHeaderId}
                            data={props.data?.location}
                        />
                    </header>
                </div>
                <div className={classNames(styles.main)}>
                    <form
                        id="productForm"
                        className={classNames(styles.mainLeft)}
                        onSubmit={onPayloadAddFormAddButtonClick}
                    >
                        <div>
                            <div className={classNames(styles.addTitle)}>
                                {t('addProductsTitle')}
                            </div>
                            <LabelStaticValue
                                label={<div>{t('selectBoxStockName')}</div>}
                                value={
                                    <SelectBox
                                        inspectorId={payloadAddFormProductWarehouseToAddSelectBoxId}
                                        dataSource={productWarehousesToAddDataSource}
                                        value={selectedProductWarehouseToAdd}
                                        onValueChanged={
                                            onProductWarehouseToAddSelectBoxValueChanged
                                        }
                                    />
                                }
                            />
                            <LabelStaticValue
                                label={<div>{t('selectBoxProductName')}</div>}
                                value={
                                    <Lookup
                                        disabled={selectedProductWarehouseToAdd === undefined}
                                        inspectorId={payloadAddFormProductToAddSelectBoxId}
                                        dataSource={productToAddDataSource}
                                        searchEnabled
                                        value={selectedProductToAdd}
                                        onValueChanged={onProductToAddSelectBoxValueChanged}
                                    />
                                }
                            />
                            {!!selectedProductToAdd && (
                                <>
                                    <Form
                                        inspectorId={payloadAddFormProductToAddInfoFormId}
                                        formData={selectedProductToAddInfoFormData}
                                        readOnly={true}
                                    />
                                    <LoadPanel
                                        position={formDetailsLoadPanelPosition}
                                        visible={selectedProductToAddInfoFormData === undefined}
                                        shadingColor="rgba(0,0,0,0.4)"
                                        showIndicator={true}
                                        shading={true}
                                        showPane={true}
                                        closeOnOutsideClick={false}
                                    />
                                    <LabelStaticValue
                                        label={<div>{t('countOfCarriersToGet')}</div>}
                                        value={
                                            <NumberBox
                                                inspectorId={payloadAddFormCountOfCarriersToGetId}
                                                value={countOfCarriersToGet}
                                                onValueChanged={(e) =>
                                                    setCountOfCarriersToGet(e.value)
                                                }
                                                disabled={
                                                    !selectedProductToAddInfoFormData?.totalAvailableProductUnitsSum
                                                }
                                            >
                                                <Validator>
                                                    <RangeRule
                                                        message={t(
                                                            'validation.carriersToGet.range',
                                                            {
                                                                max:
                                                                    selectedProductToAddInfoFormData?.totalAvailableProductUnitsSum ||
                                                                    0,
                                                                min: 0,
                                                            }
                                                        )}
                                                        min={1}
                                                        max={
                                                            selectedProductToAddInfoFormData?.totalAvailableProductUnitsSum ||
                                                            0
                                                        }
                                                    />
                                                </Validator>
                                            </NumberBox>
                                        }
                                    />
                                </>
                            )}
                            <Button
                                inspectorId={payloadAddFormOpenAdvancedButtonId}
                                onClick={toggleAdvancedStockPopup}
                            />
                            {isAdvancedStockPopupVisible && (
                                <Popup
                                    visible
                                    showTitle={true}
                                    title={t('AdvancedStockPopup')}
                                    onHiding={setAdvancedStockPopupFalse}
                                    closeOnOutsideClick={true}
                                >
                                    <div style={{ height: '100%' }}>
                                        <LoadPanel
                                            visible={insertingPayloadItemBySSCCList}
                                            shadingColor="rgba(0,0,0,0.4)"
                                            showIndicator={true}
                                            shading={true}
                                            showPane={true}
                                            closeOnOutsideClick={false}
                                        />
                                        <LayoutControl inspectorId={payloadAddFormAdvanceLayoutId}>
                                            <div layout-id={payloadAddFormAdvanceHeaderLayoutId}>
                                                <header>
                                                    <RouteLocationModelSimpleText
                                                        inspectorId={orderStepForwardFormHeaderId}
                                                        data={props.data?.location}
                                                    />
                                                </header>
                                            </div>
                                            <SelectBox
                                                inspectorId={
                                                    payloadAddFormProductWarehouseToAddSelectBoxId
                                                }
                                                dataSource={productWarehousesToAddDataSource}
                                                //
                                                value={selectedProductWarehouseToAdd}
                                                onValueChanged={
                                                    onProductWarehouseToAddSelectBoxValueChanged
                                                }
                                            />
                                            <DataGrid
                                                inspectorId={payloadAddFormProductsGridId}
                                                dataSource={productCarriersDataSource}
                                                onSelectionChanged={onAdvancedSelectionChanged}
                                                defaultSelectedRowKeys={advancedSelectedKeys}
                                            >
                                                <Template
                                                    name="AdvancedCheckBoxCell"
                                                    key="AdvancedCheckBoxCell"
                                                    component={AdvancedCheckBoxCell}
                                                />
                                            </DataGrid>
                                            <Button
                                                inspectorId={payloadAddFormAdvancedApplyButtonId}
                                                onClick={onAdvancedAddButtonClick}
                                            />
                                            <Button
                                                inspectorId={payloadAddFormAdvancedCancelButtonId}
                                                onClick={toggleAdvancedStockPopup}
                                            />
                                        </LayoutControl>
                                    </div>
                                </Popup>
                            )}
                        </div>
                        <div className={classNames(styles.addProductButton)}>
                            <Button
                                disabled={
                                    isPayloadAddFormDisable ||
                                    insertingPayloadItem ||
                                    !carrierCountInRange
                                }
                                inspectorId={payloadAddFormAddButtonId}
                            />
                        </div>
                    </form>
                    <div className={classNames(styles.mainRight)}>
                        <div className={classNames(styles.rightTop)}>
                            <div className={classNames(styles.topMenu)}>
                                <div className={classNames(styles.addTitle)}>
                                    {t('waybillTitle')}
                                </div>
                                <div className={classNames(styles.removeAllButton)}>
                                    <Button
                                        inspectorId={payloadAddFormRemoveAllButtonId}
                                        onClick={onRemoveAll}
                                    />
                                </div>
                            </div>
                            <DataGrid
                                inspectorId={payloadFormGridId}
                                dataSource={payloadDataSource}
                                repaintChangesOnly
                            >
                                <Template
                                    name="PayloadCarrierCountSimpleText"
                                    render={PayloadCarrierCountSimpleTextTemplate}
                                />
                                <Template
                                    name="AllowedStacksHeader"
                                    render={AllowedStacksHeaderTemplate}
                                />
                            </DataGrid>
                        </div>
                        <div className={classNames(styles.rightBottom)}>
                            {props?.maxCapacityReached && (
                                <label className={styles.blockedButtonsLabel}>
                                    {t('blockedButtons')}
                                </label>
                            )}
                            <ProgressBarBoxes
                                arrowDirection={enArrowDirection.Right}
                                itemsCount={props?.filledTrailerCapacity}
                                maxItemsCount={props.maxTrailerCapacity}
                                name={
                                    props.carPayloadLoadProgressTitle ??
                                    t('carPayloadLoadProgressTitle')
                                }
                                remainingTrailerSpace={props.remainingTrailerSpace}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(styles.bottom)}>
                    <Button inspectorId={payloadAddFormCancelButtonId} onClick={props.onCancel} />
                    <Button inspectorId={payloadAddFormDoneButtonId} onClick={props.onDone} />
                </div>
            </InspectorVariablesContext>
        </div>
    );
});

export default PayloadAddForm;

export type PayloadAddFormProps = {
    data?: PayloadAddFormData;
} & PayloadAddFormDisplayOptions;

export type PayloadAddFormPayloadData = {
    id?: string;
    name?: string;
    sku?: string;
    productsQuantity?: number;
    requestedAmount?: number;
    // nowo dodane ( 6 kwi. )
    stocks?: {
        items: LogisticUnitSimpleTextData[];
    };
} & PayloadCarrierCountSimpleTextData;

export const PayloadAddFormPayloadDataKeys = [
    'id',
    'name',
    'sku',
    'productsQuantity',
    'requestedAmount',
    ...PayloadCarrierCountSimpleTextDataKeys,
];

export interface PayloadAddFormDisplayOptions {
    className?: string;
    filledTrailerCapacity?: number;
    maxCapacityReached?: boolean;
    //
    createPayloadDataSource?: (
        payloadCollectionId?: string
    ) => DataSource | DataSourceOptions | undefined;
    createProductToAddDataSource?: () => DataSource | undefined;
    createWarehousesDataSource?: () => DataSource | undefined;
    createProductCarriersDataSource?: (
        warehouseId?: string
    ) => DataSource | DataSourceOptions | undefined;
    //
    getWMSDetails?: (payload: getWMSDetailsPayload) => Promise<PayloadWMSDetailsData | undefined>;
    //
    insertPayloadItemByProductId?: (
        payload: insertByProductIdToCollectionPayload
    ) => Promise<PayloadAddFormPayloadData>;
    insertPayloadItemBySSCCList?: (
        payload: insertBySSCCListToCollectionPayload
    ) => Promise<PayloadAddFormPayloadData>;
    calculateRemainingTrailerSpace?: () => Promise<void>;
    //
    carPayloadLoadProgressTitle?: string;
    onDone?: () => void;
    onCancel?: () => void;
    maxTrailerCapacity?: number;
    remainingTrailerSpace?: RemainingTrailerSpace;
}

export type PayloadAddFormData = {
    id?: string;
    //stock?: LogisticUnitSimpleTextData,
    location?: RouteLocationModelSimpleTextData;
    payload?: // items OrderStepProductItemData
    {
        id?: string;
    };
};
export type ProductToAddSelectBoxInfoData = {
    id?: string;
    sku?: string;
    name?: string;
    composite?: string; // = name + ( SKU : + sku + )}
};
export const ProductToAddSelectBoxInfoDataKeys = ['id', 'sku', 'name', 'composite'];

export type ProductToAddInfoFormData = {
    id?: string;
    sku?: string;
    name?: string;
    totalAvailableProductUnitsSum?: number;
    totalLockedProductUnitsSum?: number;
};
export const PayloadAddFormDataKeys = ['id'];

export type ProductCarrierItemData = {
    id?: string;
    carrierTypeId?: string;
    //
    carrierStatus?: string;
    carrierStatusDescription?: string;
    isStackable?: boolean;
    layersCount?: number;
    stockStatusDescription?: string;
    supplierName?: string;
    //
    carrierWarehouseStorageData?: {
        warehouseEntryDateTime?: Date;
        warehouseEntryDocumentId?: string;
    };
    //
    productId?: string;
    productName?: string;
    productUnitsOnCarrier?: number;
    stockStatus?: string;
    //
    stockAttributes?: {
        attribute1: {
            name?: string;
            value?: string;
        };
        attribute2: {
            name?: string;
            value?: string;
        };
        attribute3: {
            name?: string;
            value?: string;
        };
        attribute4: {
            name?: string;
            value?: string;
        };
        attribute5: {
            name?: string;
            value?: string;
        };
        attribute6: {
            name?: string;
            value?: string;
        };
        attribute7: {
            name?: string;
            value?: string;
        };
        attribute8: {
            name?: string;
            value?: string;
        };
        attribute9: {
            name?: string;
            value?: string;
        };
        attribute0: {
            name?: string;
            value?: string;
        };
    };
};

export const ProductCarrierItemDataKeys = [
    'id',
    'carrierStatus',
    'carrierStatusDescription',
    'isStackable',
    'layersCount',
    'stockStatusDescription',
    'supplierName',
    'carrierWarehouseStorageData.warehouseEntryDateTime',
    'carrierWarehouseStorageData.warehouseEntryDocumentId',
    'carrierTypeId',
    'productId',
    'productName',
    'productUnitsOnCarrier',
    'stockStatus',
    'stockAttributes.attribute1.name',
    'stockAttributes.attribute1.value',
    'stockAttributes.attribute2.name',
    'stockAttributes.attribute2.value',
    'stockAttributes.attribute3.name',
    'stockAttributes.attribute3.value',
    'stockAttributes.attribute4.name',
    'stockAttributes.attribute4.value',
    'stockAttributes.attribute5.name',
    'stockAttributes.attribute5.value',
    'stockAttributes.attribute6.name',
    'stockAttributes.attribute6.value',
    'stockAttributes.attribute7.name',
    'stockAttributes.attribute7.value',
    'stockAttributes.attribute8.name',
    'stockAttributes.attribute8.value',
    'stockAttributes.attribute9.name',
    'stockAttributes.attribute9.value',
    'stockAttributes.attribute0.name',
    'stockAttributes.attribute0.value',
];
